<template>
  <div class="favorites">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="ft20 c333">收藏夹</span>
        <el-button
          @click="goshopFavorites"
          class="ml20 w120 float_right"
          size="small"
          type="primary"
          >去下单</el-button
        >
        <el-button
          @click="deleFavorites"
          class="wl120 w120 float_right"
          size="small"
          type="primary"
          plain
          >删除</el-button
        >
      </div>
      <div class="favorites_content mt10">
        <el-table
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          :row-key="getRowKey"
          :header-cell-style="{
            fontSize: '13px',
            color: '#787878',
            background: '#F5F5F5',
            textAlign: 'center',
          }"
          :cell-style="{
            fontSize: '14px',
            color: '#140000',
            textAlign: 'center',
          }"
          ref="favoriteId"
          :data="tableDataList"
          tooltip-effect="dark"
          @selection-change="(val) => handleSelectionChange(val)"
        >
          <el-table-column
            label="全选"
            type="selection"
            :reserve-selection="true"
            width="55"
          >
          </el-table-column>
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <div>
                <div>
                  <img
                    width="50px"
                    height="50px"
                    :src="
                      scope.row.pictureList ?
                      JSON.parse(scope.row.pictureList)[0].urlAddress
                      : noPic
                    "
                    alt=""
                  />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="商品名称">
              <template slot-scope="scope">
                  <p class="cursorP productP" @click="orderListDet(scope.row.productCode)">{{scope.row.productName}}</p>
              </template>
          </el-table-column>
           <el-table-column prop="spec" label="商品规格"> </el-table-column>
          <el-table-column prop="saleUnitName" label="单位"> </el-table-column>
          <el-table-column prop="price" label="单价"> </el-table-column>
         
        </el-table>
        <div class="pageschange">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="total"
            :current-page="pageNum"
            prev-text="上一页"
            next-text="下一页"
            @current-change="favoriteslist()"
          >
            <!-- @next-click="nextClick"
                @prev-click="prevClick" -->
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { HomeList, reMoveOfenByfictitiousIds } from "@/api/api";
import { Storage } from "@/utils/storage";
import noPic from '@/assets/img/no_goods.png';
export default {
  name: "favorites",
  data() {
    return {
      tableDataList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      favoriteIdArr: [],
      idKey: "personId",
      noPic
    };
  },
  created() {
    this.favoriteslist();
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    // 获取收藏列表
    favoriteslist() {
      this.loading = true;
      let params = {
        ofenFlag: 1,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      HomeList(params)
        .then((res) => {
          if (res.code == 200 && res.result.data) {
            this.tableDataList = res.result.data;
            this.total = res.result.count;
            this.loading = false;
          } else {
            this.tableDataList = [];
            this.loading = false;
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 获取选中的值
    handleSelectionChange(val) {
      this.favoriteIdArr = val;
    },
    /**
     * @description: 删除收藏夹 先通过获取选中的对象后，再删除的时候通过map获取到选中的id组成新数组
     * @param {*} [id]
     * @return {*}
     * @author: txp
     */
    deleFavorites() {
      let ids = this.favoriteIdArr.map((value) => {
        return value.id;
      });
      reMoveOfenByfictitiousIds(ids)
        .then((res) => {
          if (res.code == 200) {
            this.favoriteslist();
            this.$message.warning("删除成功");
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 去下单
    goshopFavorites() {
      const dataList = [];
      this.favoriteIdArr.map((item) => {
        let obj = {
          ...item,
          productNum: 1,
          isChecked: true,
          lineType: "10",
          imgUrl:
            item.pictureList && JSON.parse(item.pictureList)[0].urlAddress,
        };
        dataList.push(obj);
      });
      Storage.l.set("orderList", JSON.stringify(dataList));
      this.$router.push({
        path: "/home/shopsesttle",
      });
    },
    // 跳转到订单详情页面
    orderListDet(productCode) {
      //商品编码
      this.$router.push({
        path: "/home/shopcardet",
        query: {
          productCode,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.favorites {
  height: 100%;
  .el-card {
    height: 100%;
    .el-card__header {
      border-bottom: 0;
      padding: 20px 20px 0px 20px;
    }
    .el-table {
      td {
        vertical-align: top; //让表格内容不垂直居中
      }
    }
    //分页
    .pageschange {
      margin: 20px auto;
      text-align: center;
    }
    .productP{
      color: $color-primary;
    }
  }
}
</style>
